'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgShare2 from '@common/icon/SvgShare2';
import dayjs from 'dayjs';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { MARKET_EVENT_END_AT } from '../../constants';
import { SnsShareDrawer } from './SnsShareDrawer';
const GOOGLE_FORM_URL = 'https://forms.gle/mGg3xYe1KGuUXyZJ9';
export const SnsShareButton = () => {
  const $ = _c(7);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = dayjs().isAfter(dayjs(MARKET_EVENT_END_AT));
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isEventEnded = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isEventEnded ? <Button className="flex-1" disabled={true}>이벤트가 종료됐어요</Button> : <Button className="flex-1" asChild={true}><CustomLink href={GOOGLE_FORM_URL} target="_blank" className="flex items-center gap-8">구글 폼 입력하기</CustomLink></Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <button type="button" className="flex-center" onClick={t2} aria-label={"\uACF5\uC720\uD558\uAE30"}><SvgShare2 /></button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isOpen) {
    t5 = <div className="flex w-full items-center gap-16">{t1}{t3}<SnsShareDrawer opened={isOpen} onClose={t4} /></div>;
    $[5] = isOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};